export default __webpack_public_path__ + "static/media/gallery.ee100da2.png";